import { FilterKey, FilterOptionInformation } from '@studyportals/search-filters';
import { FilterOptionsBase } from './FilterOptionsBase';

export class UniversityOptions extends FilterOptionsBase {
	public override isValid(): boolean {
		return true;
	}

	public override createOptions(): FilterOptionInformation[] {
		return [];
	}

	public override getFilterKey(): FilterKey {
		return FilterKey.ORGANISATIONS;
	}
}
